(function() {
  'use strict';

  function MenuSettingsLinksDirective() {
    function MenuSettingsLinksController(RouterHelper, $q, Security, Features, Organisation) {
      var ctrl = this;

      // Start all as invisible
      ctrl.showMainLink = false;
      ctrl.canManageLabsSettings = false;
      ctrl.canManageOrganisationSettings = false;
      ctrl.canManageProtectedSettings = false;
      ctrl.canViewAiUsage = false;

      var manageLabsSettingsPromise = Security.hasPermission(
        'features.manage', { promise: true }
      )
        .then(function() {
          return Organisation.currentOrganisation()?.enabledLabs;
        }).catch(function() {
          return false;
        });

      var manageOrganisationSettingsPromise = Security.hasPermission(
        'features.manage', { promise: true }
      )
        .then(function() {
          return Features.freeFeatures().length > 0;
        }).catch(function() {
          return false;
        });

      var manageProtectedSettingsPermission = Security.hasRole(
        'system:superadmin', { promise: true }
      )
        .then(function() {
          return true;
        }).catch(function() {
          return false;
        });

      var manageAiUsagePromise = Security.hasPermission(
        'aiassistant.manage', { promise: true }
      )
        .then(function() {
          return true;
        }).catch(function() {
          return false;
        });

      $q.all([
        manageLabsSettingsPromise,
        manageOrganisationSettingsPromise,
        manageProtectedSettingsPermission,
        manageAiUsagePromise
      ])
        .then(function(results) {
          ctrl.canManageLabsSettings = results[0]; // manageLabSettingsPromise
          ctrl.canManageOrganisationSettings = results[1]; // manageOrganisationSettingsPromise
          ctrl.canManageProtectedSettings = results[2]; // manageProtectedSettingsPromise
          ctrl.canManageIndexingStatus = results[2];
          ctrl.canManageTrash = results[2];
          ctrl.canViewAiUsage = results[3]; // manageAiUsagePromise

          // If any is visible, show the dropdown menu trigger
          ctrl.showMainLink = ctrl.canManageLabsSettings ||
            ctrl.canManageOrganisationSettings ||
            ctrl.canManageProtectedSettings ||
            ctrl.canViewAiUsage;
        });

      ctrl.hasActiveLinks = function() {
        var states = [
          'epf.settings.labs',
          'epf.settings.organisation',
          'epf.settings.protected',
          'epf.settings.aiusage'
        ];
        var currentState = RouterHelper.getState();
        return states.some(function(s) {
          return currentState === s;
        });
      };
    }

    MenuSettingsLinksController.$inject = [
      'RouterHelperService',
      '$q',
      'SecurityService',
      'FeaturesService',
      'OrganisationService'
    ];

    return {
      restrict: 'EA',
      templateUrl: 'app/layout/header/kz-menu-settings-links.html',
      replace: true,
      controller: MenuSettingsLinksController,
      controllerAs: 'menuSettingsCtrl'
    };
  }

  angular.module('kzHeaderCard')
    .directive('kzMenuSettingsLinks', MenuSettingsLinksDirective);
})();
